import { render, staticRenderFns } from "./time-reservation-legacy.vue?vue&type=template&id=66ae9758&scoped=true&lang=pug&functional=true"
import script from "./time-reservation-legacy.vue?vue&type=script&lang=js"
export * from "./time-reservation-legacy.vue?vue&type=script&lang=js"
import style0 from "./time-reservation-legacy.vue?vue&type=style&index=0&id=66ae9758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "66ae9758",
  null
  
)

export default component.exports